export function searchNodeNameUp(e, found, notFound, options) {
    let target = e.target;
    let level = 0;
    while (target) {
        const nodeName = target.nodeName;
        const className = target.getAttribute('class');
        if (
            nodeName === options.search ||
            options.exceptions.includes(nodeName) ||
            (level === 0 && className && className.includes(options.border))
        ) {
            return found && found(e);
        } else if (className && className.includes(options.border)) {
            return notFound(e);
        } else {
            level++;
            target = target.parentElement;
        }
    }
}

export function replaceInnerHTML(tag, toInsert, html, options = {}) {
    const div = document.createElement('div');
    const prefixRegex = new RegExp(`<${tag} (.*?)>`, 'g');
    if (!options.keepTags) {
        html = html.replace(prefixRegex, '').replace(`</${tag}>`, '');
    }
    div.innerHTML = html.trim();
    let toReplace = div;
    if (options.forced) {
        toReplace = toReplace.children[0] ? toReplace.children[0] : toReplace;
    } else {
        while (toReplace.children[0]) {
            toReplace = toReplace.children[0];
        }
    }
    if (options.html && toInsert) {
        toReplace.innerHTML = toInsert;
    } else if (toInsert) {
        toReplace.innerText = toInsert;
    }
    return div.innerHTML;
}

export function htmlElementFromString(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
}

export function imageFixRTE(htmlString) {
    const regexImage = /<\s*div(.*?)ce-element--type-image(.*?)>(.*?)<\s*\/s*div>/g;
    return htmlString.replace(regexImage, (match) => {
        const widthRegex = /\s*width:(.*?)px\s*/g;
        const width = match.match(widthRegex)[0].replace('width:', '').replace('px', '');
        const heightRegex = /\s*height:(.*?)px\s*/g;
        const height = match.match(heightRegex)[0].replace('height:', '').replace('px', '');
        const imageRegex = /\s*background-image:\s*url\((.*?)\);\s*/g;
        const image = match.match(imageRegex)[0].replace('background-image:url(', '').replace(');', '');
        const classRegex = /\s*class="(.*?)"\s*/g;
        const htmlClass = match
            .match(classRegex)[0]
            .replace('class=', '')
            .replace('ce-element--type-image', '')
            .replace('ce-element', '');
        return `<img class=${htmlClass} height="${height}" src=${image} width="${width}">`;
    });
}



// WEBPACK FOOTER //
// ./src/lib/dom.utils.js